import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';

const COLORS = {
  brand: 'tw-border-brand-300',
  black: 'tw-border-black',
  white: 'tw-border-white',
};

type LoadingColor = keyof typeof COLORS;

export interface LoadingProps {
  className?: string;
  color?: LoadingColor;
}

const Loading = ({ className, color = 'brand' }: LoadingProps) => (
  <div className={classNames('tw-flex tw-justify-center tw-py-4', className)}>
    <span
      className={`tw-rounded-full tw-w-8 tw-h-8 tw-border-4 ${COLORS[color]} tw-border-r-transparent tw-animate-spin`}
    />
  </div>
);

export default Loading;
